<template>
    <div>
        <market-title :iconClass="'icona'"
            :title="'积分福利'"
            :des="'可设置积分活动，给予顾客消费奖励，激励顾客主动消费'">
            <div class="fx fx-h-end">
                <button class="text-btn" @click="openPointsSetting">积分设置</button>
            </div>
        </market-title>
        <point-use-rules ref="pointUseRules"></point-use-rules>
        <point-setting ref="pointSetting"></point-setting>
        <points-table />
    </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { createComponent } from '@vue/composition-api'
import MarketTitle from '../components/market_title.vue'
import PointUseRules from './components/points_use_rules_setting.vue'
import PointSetting from './components/points_setting.vue'
import PointsTable from './components/points_table.vue'

export default createComponent({
    setup(props, ctx) {

        function openPointsSetting() {
            (ctx.refs.pointSetting as any).open()
        }

        return {
            openPointsSetting
        }
    },


    components: {
        MarketTitle,
        PointUseRules,
        PointSetting,
        PointsTable
    }
})
</script>